/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownload interface.
 */
export function instanceOfFtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownload(value) {
    if (!('DownloadBaseUri' in value) || value['DownloadBaseUri'] === undefined)
        return false;
    return true;
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadFromJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadFromJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DownloadBaseUri': json['downloadBaseUri'],
    };
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadToJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadToJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'downloadBaseUri': value['DownloadBaseUri'],
    };
}
//# sourceMappingURL=FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownload.js.map